

export const DIALOG_TYPE = 'DIALOG_WEBFIRST_BILLS_SCOUT';
